import { render, staticRenderFns } from "./Inviter.vue?vue&type=template&id=2d188cb0&scoped=true"
import script from "./Inviter.vue?vue&type=script&lang=js"
export * from "./Inviter.vue?vue&type=script&lang=js"
import style0 from "./Inviter.vue?vue&type=style&index=0&id=2d188cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d188cb0",
  null
  
)

export default component.exports